import React from "react";
import { makeStyles } from "@material-ui/core";
import { Container, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  geoSection: {
    padding: "60px 0",
    backgroundColor: "#f8f9fa",
  },
  container: {
    textAlign: "center",
  },
  geoText: {
    fontSize: "1.125rem",
    lineHeight: "1.8",
    color: "#2D2D2D",
    maxWidth: "900px",
    margin: "0 auto",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
      textAlign: "left",
    },
  },
}));

const GeoSection = ({ serviceType }) => {
  const classes = useStyles();

  return (
    <div className={classes.geoSection}>
      <Container maxWidth="lg" className={classes.container}>
        <Typography variant="body1" className={classes.geoText}>
          Kinetx Co provides professional {serviceType} throughout Miami-Dade 
          (Brickell, Wynwood, Coral Gables, Doral, Aventura, Miami Beach, 
          Downtown Miami, Kendall, Coconut Grove, South Beach, Homestead, 
          and the greater Miami area) and New York City (Manhattan, Brooklyn, 
          Queens, The Bronx, Staten Island, Long Island City, Williamsburg, 
          DUMBO, and surrounding areas).
        </Typography>
      </Container>
    </div>
  );
};

export default GeoSection;

